module.exports = __webpack_public_path__ + "img/golf-booking-icon.1b4f4796.svg";